import React from "react";

function UiPanel({children}) {
    return (
        <div className="ui-panel p-2 pr-3 pl-3 mt-3">{ children }</div>
    )
}

export default UiPanel;